import type { ReactNode } from "react";
import { Icon, type IconName } from "./Icon";

/**
 * Yig'ma ko'rsatkich — katta raqam.
 *
 * Raqam sahifadagi eng ko'zga tashlanadigan narsa, yorliq esa
 * kichik va kulrang. Holat (`accent`) raqamni bo'yamaydi —
 * yorliq oldidagi rangli nuqta bilan ko'rsatiladi; faqat xato
 * raqamning o'zini qizil qiladi.
 */
export function MetricCard({
  label,
  value,
  hint,
  icon,
  accent,
  loading,
  extra,
}: {
  label: string;
  value: number | string | undefined;
  hint?: string;
  icon?: IconName;
  accent?: "error" | "warning" | "success";
  loading?: boolean;
  /** Qiymat yonidagi qo'shimcha belgi (masalan solishtirish farqi). */
  extra?: ReactNode;
}) {
  return (
    <article className={`card-glass glass metric-card${accent ? ` metric-accent-${accent}` : ""}`}>
      <div className="metric-head">
        <span className="metric-label">{label}</span>
        {icon && <Icon name={icon} size={16} className="metric-icon" />}
      </div>

      {loading ? (
        <div className="skeleton" style={{ height: 40, width: 88, marginTop: 12 }} />
      ) : (
        <div className="metric-value num">
          {value ?? "—"}
          {extra}
        </div>
      )}

      {hint && <div className="metric-hint">{hint}</div>}
    </article>
  );
}
